module.exports = __webpack_public_path__ + "img/board_top.b8e4a8f3.png";